import { render, staticRenderFns } from "./UsePlatformGraphicWeek.vue?vue&type=template&id=95e46b50"
import script from "./UsePlatformGraphicWeek.vue?vue&type=script&lang=js"
export * from "./UsePlatformGraphicWeek.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports